var map = {
	"./svg/day/marker.svg": 72,
	"./svg/day/marker_active.svg": 73,
	"./svg/day/position.svg": 74,
	"./svg/gps.svg": 137,
	"./svg/headphones.svg": 138,
	"./svg/night/marker.svg": 75,
	"./svg/night/marker_active.svg": 76,
	"./svg/night/position.svg": 77,
	"./svg/phone.svg": 139,
	"./svg/texture.svg": 71
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;